
import Phaser from 'phaser';
import EDC from '../../../shared/globals';

EDC.Animations.Dragonfly = function (scene) {
  this.scene = scene;
  this.destinationPoints = [
    new Phaser.Geom.Point(343, 852),
    new Phaser.Geom.Point(509, 770),
    new Phaser.Geom.Point(1084, 750),
    new Phaser.Geom.Point(1210, 920),
    new Phaser.Geom.Point(1440, 700),
  ];
  this.dragonfly = null;
  this.speed = this.scene.game.config.width / 2500;
  this.buzzTween = null;
};

EDC.Animations.Dragonfly.prototype.create = function () {
  const point = this.getRandomDestination();
  this.dragonfly = this.scene.add.sprite(point.x, point.y, 'dragonfly');
  this.start(false);
};

EDC.Animations.Dragonfly.prototype.start = function (force) {
  let time = this.getRandomTime();
  if (force) {
    time = 10;
  }
  this.scene.time.addEvent({
    delay: time,
    callback: this.fly,
    callbackScope: this,
  });
};

EDC.Animations.Dragonfly.prototype.fly = function () {
  const point = this.getRandomDestination();
  if (this.dragonfly.x === point.x) {
    this.start(true);
    return;
  }
  if (this.dragonfly.x > point.x) {
    this.dragonfly.setScale(-1, 1);
  } else {
    this.dragonfly.setScale(1, 1);
  }
  /* var tween = this.game.add.tween(this.dragonfly).to({x: point.x, y: point.y},
     this.getFlyTime(point), Phaser.Easing.Linear.None, true);
    tween.onComplete.add(function() {
        this.start(false);
    }, this); */
  this.scene.tweens.add({
    targets: this.dragonfly,
    x: point.x,
    y: point.y,
    duration: this.getFlyTime(point),
    ease: 'Linear',
    onComplete: function () {
      this.start(false);
    }.bind(this),
  });
};

EDC.Animations.Dragonfly.prototype.getRandomDestination = function () {
  const idx = Math.floor(Math.random() * this.destinationPoints.length);
  return this.destinationPoints[idx];
};

EDC.Animations.Dragonfly.prototype.getRandomTime = function () {
  return 1000 * 5 + Math.round(Math.random() * (1000 * 5));
};

EDC.Animations.Dragonfly.prototype.getFlyTime = function (point) {
  const distance = Math.abs(this.dragonfly.x - point.x);
  return distance * this.speed;
};

export default EDC.Animations.Dragonfly;
